var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPortal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_99265",
    "data-name": "Group 99265",
    transform: "translate(-623 -589.461)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 41.5,
    cy: 41.5,
    r: 41.5,
    transform: "translate(623 589.461)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_1",
    "data-name": "Polygon 1",
    transform: "translate(680.996 615.539) rotate(90)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.344,0,30.688,27.006H0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 15.34414386749268 4.048501968383789 L 3.436651229858398 25.00569915771484 L 27.25163650512695 25.00569915771484 L 15.34414386749268 4.048501968383789 M 15.34414386749268 0 L 30.68828392028809 27.00569915771484 L 3.814697265625e-06 27.00569915771484 L 15.34414386749268 0 Z",
    stroke: "none",
    fill: "#d22524"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortal);
export default __webpack_public_path__ + "static/media/portal.3f504e46708dc2d529396db333b0c913.svg";
export { ForwardRef as ReactComponent };